import React, { useState, useEffect } from "react";
import { CardContent, CardHeader, Typography, Card, CardMedia, Box } from "@mui/material";
import { DESKTOP_FORMULA_IMAGES, MOBILE_FORMULA_IMAGES } from "../utils/dataFormula";

const Formula = ({ width }) => {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const isMobile = windowWidth <= 768;
  
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Desktop and mobile images from dataFormula.js
  const desktopImages = DESKTOP_FORMULA_IMAGES;
  const mobileImages = MOBILE_FORMULA_IMAGES;

  return (
    <div className="colorbase text-center" style={{ paddingTop: 100 }}>
      <div>
        <CardHeader
          title={
            <h2 className="text-lighting">
              สมมติฐานที่ใช้คำนวณ
            </h2>
          }
        />
      </div>
      <div>
        <div className="w-100 container">
          <div className={"w-100 container mt-5 "}>
            <Card>
              <CardContent className="text-left">
                <CardHeader title={<h5 className="colorbase">คำชี้แจง</h5>} />
                <Typography>
                  <b>1. สมมติฐานการประมาณการรายได้ ณ เกษียณ ประกอบด้วย</b>
                </Typography>
                <Typography>
                  <b>1.1 ประมาณการเงินจาก กบข.</b>
                </Typography>
                <Typography>
                  - การประมาณการเงินที่คาดว่าสมาชิกจะได้รับจาก กบข. คำนวณโดยตั้งต้นจากอัตราเงินเดือนและยอดเงิน
                  ในบัญชีปัจจุบันของสมาชิก และประมวลผลข้อมูลในอนาคตจากสมมติฐานที่สมาชิกกรอกและสมมติฐานด้านการลงทุน
                  จากการประเมินสถานการณ์การตามแบบจำลองทางสถิติของกองทุน โดยยอดเงินประมาณการตามที่แสดงในแอปพลิเคชันนี้รวมเงิน
                  ทุกประเภทในบัญชีสมาชิก ซึ่งสมาชิกจะได้รับก็ต่อเมื่อสมาชิกมีสิทธิ์รับและเลือกรับบำนาญเท่านั้น
                </Typography>
                <Typography>
                  <b>1.2 ประมาณการเงินบำนาญจาก กรมบัญชีกลาง</b>
                </Typography>
                <Typography>
                  - การประมาณการเงิน<b>บำนาญรายเดือน</b>ที่คาดว่าสมาชิกจะได้รับจากกรมบัญชีกลาง 
                  คำนวณโดยตั้งต้นจากอัตราเงินเดือนปัจจุบันของสมาชิก 
                  และประมาณการข้อมูลในอนาคตจากสมมติฐานที่สมาชิกกรอก เช่น อัตราขึ้นเงินเดือน อัตราเงินเดือนสูงสุด (มีสมมติฐานขยายอัตราเงินเดือนสูงสุด 5% ทุก 5 ปี) เป็นต้น จากนั้นคำนวณเงินบำนาญ
                  โดยใช้หลักเกณฑ์การคำนวณเงินบำนาญตามที่กำหนดในมาตรา 63 ของ พรบ. กบข. ปี 2539 ดังนี้
                  เวลาราชการสำหรับคำนวณเงินบำนาญไม่รวมถึงเวลาราชการทวีคูณหรือเวลาราชการ ที่ต้องถูกหักออก
                  เนื่องจากการลาไปศึกษา ฝึกอบรม ดูงาน หรือปฏิบัติการวิจัย หรือไปสมัครรับเลือกตั้ง หรือด้วยเหตุอื่นใด
                </Typography>
                <Typography>
                  - ประมาณการเงินบำนาญรายเดือน คำนวณตามหลักเกณฑ์การคำนวณเงินบำนาญตามที่กำหนดในมาตรา 63
                  ของ พรบ. กบข. ปี 2539 และ เฉพาะในเมนู My Digital Twins เท่านั้น
                </Typography>
                
                {/* Desktop Images */}
                <Box sx={{ display: { xs: "none", md: "block" } }}>
                  {desktopImages.map((imageUrl, index) => (
                    <CardMedia
                      key={index}
                      component="img"
                      image={imageUrl}
                      alt={`Desktop formula ${index + 1}`}
                      sx={{ 
                        width: "90%", 
                        mx: "auto", 
                        display: "block",
                        mb: 2
                      }}
                    />
                  ))}
                </Box>

                {/* Mobile Images */}
                <Box sx={{ display: { xs: "block", md: "none" } }}>
                  {mobileImages.map((imageUrl, index) => (
                    <CardMedia
                      key={index}
                      component="img"
                      image={imageUrl}
                      alt={`Mobile formula ${index + 1}`}
                      sx={{ 
                        width: "90%", 
                        mx: "auto", 
                        display: "block",
                        mb: 2
                      }}
                    />
                  ))}
                </Box>
                <Typography>
                  - การประมาณการเงิน<b>บำนาญเป็นเงินก้อน</b> มาจากยอดรวมของประมาณการเงินบำนาญรายเดือนที่คาดว่าสมาชิกจะได้รับงาน
                  ถึงอายุขัยที่สมาชิกระบุ แล้วคิดลดเป็นมูลค่าปัจจุบัน ณ วันเกษียณด้วยอัตราผลตอบแทนหลังเกษียณ 2.60% ต่อปี ทั้งนี้ การคำนวณเงินก้อนบำนาญมีความซับซ้อน
                  หากสมาชิกคำนวณด้วยตนเอง ตัวเลขที่ได้อาจไม่ตรงกับข้อมูลที่แสดงผลในแอปพลิเคชันนี้
                </Typography>
                <Typography>
                  <b>2. เป้าหมายทางการเงิน ณ เกษียณ หรือ MLS (Minimum Lump Sum)</b>
                </Typography>
                <Typography>
                - การประมาณการเงินก้อนที่สมาชิก 'ควรจะมี' เมื่อเกษียณสำหรับบรรลุเป้าหมายทางการเงิน ณ เกษียณ
                ในระดับต่าง ๆ ซึ่งมาจากการสำรวจค่าใช้จ่ายของสมาชิก กบข. ที่เกษียณอายุราชการตามการศึกษาความเพียงพอ
                โดยมีสมมติฐานว่า ค่าใช้จ่ายเพิ่มขึ้น 2.00% ต่อปี แล้วคิดลดเป็นมูลค่าปัจจุบัน ณ วันเกษียณด้วยอัตราผลตอบแทนหลังเกษียณ 2.60% ต่อปี
                 ทั้งนี้ ค่าใช้จ่ายดังกล่าวยังไม่รวมภาระหนี้สินและค่าใช้จ่ายด้านที่อยู่อาศัย (สมาชิกศึกษารายละเอียดเพิ่มเติมได้ที่ รายงานประจำปี 2567 หน้า 81-85)
                </Typography>
                <CardHeader title={<h5 className="mt-3 colorbase">ข้อสงวนสิทธิ์</h5>} />
                <Typography>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  กบข. ไม่ได้รับประกันว่าประมาณการเงินที่คาดว่าสมาชิกจะได้รับจาก กบข.* และประมาณการเงินบำนาญที่คาดว่าสมาชิกจะได้รับจากกรมบัญชีกลาง** ตามการประมวลผล
                  และแสดงในแอปพลิเคชันนี้ จะเป็นจำนวนเงินที่สมาชิกจะได้รับจริงเมื่อสมาชิกออกจากราชการ
                  </Typography>
                  <Typography>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  *จำนวนเงินที่สมาชิกจะได้รับจาก กบข. จริง ขึ้นอยู่กับผลตอบแทนที่เกิดขึ้นจากแผนการลงทุนที่สมาชิกเลือกลงทุน
                   จำนวนเงินที่สมาชิกนำส่ง และวันที่ขอรับเงินจาก กบข.
                  </Typography>
                  <Typography>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  **กรณีสมาชิกต้องการสอบถามข้อมูลเพิ่มเติมเกี่ยวกับเงินบำนาญ โปรดติดต่อ กรมบัญชีกลาง โทร. 0-2270-6400 
                  หรือสำนักงานคลังเขตของกรมบัญชีกลางทุกแห่ง
                  </Typography>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Formula;
